export default __webpack_public_path__ + "static/media/squirrel@3x.407fd508.png";